import * as moment from 'moment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IMachineJobsFilter, IMachineState } from 'app/models';
import { Constants } from '@config/constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { ErrorHandlingService } from '../error-handling/error.handling.service';

@Injectable()
export class DataStateService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly errorHandlingService: ErrorHandlingService
  ) { }

  findAllMachineStatesByCustomer = (
    customerId: number
  ): Observable<IMachineState[]> =>
    this.http
      .get<IMachineState[]>(
        this.constants.DATASTATE_BY_CUSTOMER_ENDPOINT + `/${customerId}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  getAllMachineStates(
    customerId: number,
    machineId?: number,
    description?: string,
    from?: Date,
    to?: Date,
    state?: string
  ): Observable<IMachineState[]> {
    let params = new HttpParams();
    params = params.set('customerId', customerId.toString());

    if (machineId) {
      params = params.set('machineId', machineId.toString());
    }

    if (description) {
      params = params.set('description', description);
    }

    if (from) {
      params = params.set('from', from.toISOString());
    }

    if (to) {
      params = params.set('to', to.toISOString());
    }

    if (state) {
      params = params.set('state', state);
    }
    return this.http
      .get<IMachineState[]>(this.constants.DATASTATE_ENDPOINT, { params })
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );
  }

  getRunningRatio = ({
    machineId,
    dateRange: { startDate, endDate } = {
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
    },
    zoneId,
  }: IMachineJobsFilter): Observable<number> =>
    this.http
      .get<number>(
        `${this.constants.DATASTATE_RUNNING_RATIO_ENDPOINT
        }?machineId=${machineId}&from=${moment(startDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        )}&to=${moment(endDate).format('YYYY-MM-DDTHH:mm:ss')}&zoneId=${zoneId}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  getWaitRatio = ({
    machineId,
    dateRange: { startDate, endDate } = {
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
    },
    zoneId,
  }: IMachineJobsFilter): Observable<number> =>
    this.http
      .get<number>(
        `${this.constants.DATASTATE_WAIT_RATIO_ENDPOINT
        }?machineId=${machineId}&from=${moment(startDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        )}&to=${moment(endDate).format('YYYY-MM-DDTHH:mm:ss')}&zoneId=${zoneId}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  getErrorRatio = ({
    machineId,
    dateRange: { startDate, endDate } = {
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
    },
    zoneId,
  }: IMachineJobsFilter): Observable<number> =>
    this.http
      .get<number>(
        `${this.constants.DATASTATE_ERROR_RATIO_ENDPOINT
        }?machineId=${machineId}&from=${moment(startDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        )}&to=${moment(endDate).format('YYYY-MM-DDTHH:mm:ss')}&zoneId=${zoneId}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );
}
